<script setup lang="ts">
// TODO: this component needs some work.
// it's very volunteerly-specific and also used on other pages besides the vacancy details page.

const { defaultBackTo = '/vacancies' } = defineProps<{
  defaultBackTo?: string
}>()

const { t } = useI18n({
  useScope: 'local',
})

const { goBack, getBackRoute } = useBack(defaultBackTo)

// This is not 100% robust. I don't like the route hardcoding, but it's also
// not a huge issue if it fails because the generic link works fine in all cases.
const searchPagesPaths = [
  '/vacancies',
  '/workshops',
  '/evenementen',
  '/een-op-een-hulp',
]

const backRouteIsSearchPage = computed(() => {
  // Loop over searchPages and check if the route starts with any of them
  const routeString = getBackRoute && getBackRoute()?.toString()

  // Add and edit pages are not search pages
  if (routeString?.includes('/add') || routeString?.includes('/edit')) return false

  if (!routeString) return false
  return (
    searchPagesPaths.filter(path => routeString.startsWith(path)).length > 0
  )
})
</script>

<template>
  <NuxtLink
    to="#"
    @click.prevent="goBack"
  >
    <Icon name="ph:arrow-left" class="mb-1 block size-5" />
    {{ t(backRouteIsSearchPage ? 'backToSearch' : 'backGeneric') }}
  </NuxtLink>
</template>

<i18n lang="json">
{
  "en": {
    "backToSearch": "Back to search results",
    "backGeneric": "Back"
  },
  "nl": {
    "backToSearch": "Terug naar zoekresultaten",
    "backGeneric": "Terug"
  }
}
</i18n>
